<div class="textarea-wrapper" #inputFef>
  @if (!isAutoHeight) {
    <textarea
      type="text"
      [(ngModel)]="value"
      [placeholder]="placeholder"
      class="lib-cm-textarea"
      spellcheck="false"
      [disabled]="disabled"
      [ngClass]="{ clearable: clearable,'border-highlighted': !!val && highlightIfSet }"
      [attr.rows]="rows"
      [maxlength]="maxlength"
      >
    </textarea>
  }
  @if (isAutoHeight) {
    <textarea
      type="text"
      cdkTextareaAutosize
      #cfcAutosize="cdkTextareaAutosize"
      [(ngModel)]="value"
      (ngModelChange)="resize()"
      [placeholder]="placeholder"
      class="lib-cm-textarea"
      spellcheck="false"
      [disabled]="disabled"
      [ngClass]="{ clearable: clearable, 'border-highlighted': !!val && highlightIfSet}"
      [ngStyle]="{'overflow': 'hidden', 'resize': 'vertical'}"
      >
    </textarea>
  }
  @if (!!val && clearable) {
    <span class="reset-btn" id="atqa-reset-btn" (click)="reset()">
      <i class="material-icons" [class.highlighted]="highlightIfSet">close</i>
    </span>
  }
</div>
